import DataTable, { defaultThemes, PaginationOptions } from 'react-data-table-component';
import { IEvento } from "../../interfaces/IEvento";

const EventoTabela = ({ filtro, colunas, itens, FiltroHeader }: { filtro: string, colunas: any, itens: IEvento[], FiltroHeader?: () => JSX.Element }) => {
    console.log(itens);
    const customStyles = {
        headCells: {
            style: {
                color: '#5E6397',
                fontFamily: 'Assistant',
                fontSize: '16px',
                paddingTop: '15px',
                paddingBottom: '15px',
                ':last-child': {
                    // maxWidth: '120px',
                    borderRightStyle: 'solid',
                    borderRightWidth: '1px',
                    borderRightColor: defaultThemes.default.divider.default
                },
                ':first-child': {
                    minWidth: '40%',
                    maxWidth: '50%',
                    borderLeftStyle: 'solid',
                    borderLeftWidth: '1px',
                    borderLeftColor: defaultThemes.default.divider.default
                },
                borderTopStyle: 'solid',
                borderTopWidth: '1px',
                borderTopColor: defaultThemes.default.divider.default
            },
        },
        cells: {
            style: {
                color: '#A3A3A3',
                fontFamily: 'Merriweather Sans',
                fontSize: '16px',
                paddingTop: '15px',
                paddingBottom: '15px',
                ':last-child': {
                    // maxWidth: '120px',
                    borderRightStyle: 'solid',
                    borderRightWidth: '1px',
                    borderRightColor: defaultThemes.default.divider.default
                },
                ':first-child': {
                    minWidth: '40%',
                    maxWidth: '50%',
                    borderLeftStyle: 'solid',
                    borderLeftWidth: '1px',
                    borderLeftColor: defaultThemes.default.divider.default,
                    color: '#525252'
                },
                borderBottomStyle: 'solid',
                borderBottomWidth: '1px',
                borderBottomColor: defaultThemes.default.divider.default
            }
        }
    };

    const paginationComponentOptions: PaginationOptions = {
        rowsPerPageText: 'Eventos por página',
        rangeSeparatorText: 'de',
        selectAllRowsItem: true,
        selectAllRowsItemText: 'Todos',
    };

    return <>
        {
            FiltroHeader != null && <FiltroHeader />
        }
        {
            itens.length > 0 ?
                <DataTable paginationPerPage={50} columns={colunas} data={itens.filter((item) => {
                    if (filtro) {
                        return item.nome.trim().toLowerCase().includes(filtro.trim().toLocaleLowerCase());
                    } else {
                        return item;
                    }
                })} pagination paginationComponentOptions={paginationComponentOptions} customStyles={customStyles} dense /> : <h2 className="mt-5">Não possuem eventos para serem exibidos</h2>
        }
    </>
}


export default EventoTabela;